/** @jsxImportSource @emotion/react */

import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

export default function OccConfirm({
  open = true,
  title = null,
  onCancel = () => {},
  onConfirm = () => {},
  content = <></>,
  children = null,
  confirmName = '확인',
  cancelName = '취소', // 취소 버튼 문구(i18n 키). 기본값은 기존과 같다.
  width = '314px',
  confirmBtnDisabled,
  contentPadding = '30px 40px',
}) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      title={title}
      width={width}
      styles={{
        content: { padding: contentPadding },
        header: { marginBottom: '26px' },
        footer: {
          marginTop: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
      onCancel={() => onCancel()}
      centered={true}
      footer={[
        <Button
          css={styles.button}
          style={{ border: '1px solid #555555', color: '#555555' }}
          key="cancel"
          onClick={() => onCancel()}
        >
          {t(cancelName)}
        </Button>,
        <Button
          css={styles.button}
          key="back"
          type="primary"
          onClick={() => onConfirm()}
          disabled={confirmBtnDisabled}
        >
          {t(confirmName)}
        </Button>,
      ]}
      closeIcon={null}
    >
      {children ? children : content}
    </Modal>
  );
}

const styles = {
  modal: {},
  button: {
    height: '36px',
    padding: '10px 22px',
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
  },
};
